export const historyConst = {
  CLEAR_HISTORY_STEPS: 'CLEAR_HISTORY_STEPS',
  SET_HISTORY_STEPS: 'SET_HISTORY_STEPS',
  UPDATE_HISTORY_STEPS: 'UPDATE_HISTORY_STEPS',
  SET_HISTORY_STEP_INDEX: 'SET_HISTORY_STEP_INDEX',
};
